import { TableViewStore, BaseListViewStore, DateRangeQueryPickerStore, BaasicDropdownStore } from "core/stores";
import { ImportService } from 'application/import/services';
import { FacilityService } from "application/facility/services";
import { PersonService } from "application/person/services";
import { toDate } from 'core/utils';
import _ from 'lodash';
import { action, observable } from "mobx";
import applicationContext from 'core/utils/applicationContext';

@applicationContext
class PatientsByCategoryReportListViewStore extends BaseListViewStore {
	@observable accessor downloadUrl = null;
	constructor(rootStore) {
        const importService = new ImportService(rootStore.application.baasic.apiClient);

        super(rootStore, {
			autoInit: true,
			name: 'patients-by-category-report',
			routes: {

			},
			actions: () => {
				return {
					find: async params => {
						const response = await importService.getPatientsByCategory(params);
						const responseData = _.extend(response,
							{
								item: response.item.map(i => {
									return {
										facilityName: i.facilityName,
										corporate: i.corporate,
										dateOfService: i.dateOfService && toDate(i.dateOfService),
										enteral: i.enteral,
										wound: i.wound,
										ostomy: i.ostomy,
										trache: i.trache,
										urological: i.urological
									};
								})
							});
						this.onFindSuccess();
						return responseData;
					}
				};
			},
		});

        this.facilityService = new FacilityService(rootStore.application.baasic.apiClient);
        this.personService = new PersonService(rootStore.application.baasic.apiClient);
        this.rangeQueryPickerStore = new DateRangeQueryPickerStore();
        this.setTableStore(
			new TableViewStore(this.queryUtility, {
				columns: [
					{
						key: 'facilityName',
						title: "PATIENTS_BY_CATEGORY_REPORT.LIST.COLUMNS.FACILITY_NAME",
						sortable: false,
						width: 350
					},
					{
						key: 'corporate',
						title: "PATIENTS_BY_CATEGORY_REPORT.LIST.COLUMNS.CORPORATE",
						sortable: false,
						width: 350
					},
					{
						key: 'dateOfService',
						title: "PATIENTS_BY_CATEGORY_REPORT.LIST.COLUMNS.DATE_OF_SERVICE",
						sortable: false
					},
					{
						key: 'enteral',
						title: "PATIENTS_BY_CATEGORY_REPORT.LIST.COLUMNS.ENTERAL",
						sortable: false
					},
					{
						key: 'urological',
						title: "PATIENTS_BY_CATEGORY_REPORT.LIST.COLUMNS.UROLOGICAL",
						sortable: false
					},
					{
						key: 'ostomy',
						title: "PATIENTS_BY_CATEGORY_REPORT.LIST.COLUMNS.OSTOMY",
						sortable: false
					},
					{
						key: 'trache',
						title: "PATIENTS_BY_CATEGORY_REPORT.LIST.COLUMNS.TRACHE",
						sortable: false
					},
					{
						key: 'wound',
						title: "PATIENTS_BY_CATEGORY_REPORT.LIST.COLUMNS.WOUND",
						sortable: false
					},					
				],
				actions: {
				},
			})
		);

        this.queryUtility.onResetFilter = ()=>{
            this.facilityStore.setValue(null);
            this.facilityStore.filterTerm = "";

            this.personStore.setValue(null);    
            this.personStore.filterTerm = "";

           this.rangeQueryPickerStore.reset();
        }

        this.facilityStore = new BaasicDropdownStore({
			filterable: true
		}, {
			fetchFunc: async(term) => {
                const response = await this.facilityService.find({ isActive: true, searchQuery: term, rpp: 100 });
				
				return response.data.item;          
             }
		});

        this.personStore = new BaasicDropdownStore({
			filterable: true
		}, {
            fetchFunc: async (term) => {
                const response = await this.personService.find({ searchQuery: term, rpp: 100, isActive:true });
                return _.map(response.data.item, item => {
                    return {
                        id: item.id,
                        name: item.firstName + ' ' + item.lastName                       
                    };
                });
            }
        });
    }
	@action.bound
	onFindSuccess() {
		const importService = new ImportService(this.rootStore.application.baasic.apiClient);
		const parameters = this.queryUtility.plainFilter;
		let operator = parameters.dateFrom === undefined && parameters.dateTo=== undefined && parameters.facilityId ===undefined ? '?' : '&';
		this.downloadUrl = `${importService.getDownloadUrl(parameters)+operator}contentDisposition=attachment&token=${
            this.rootStore.authStore.token.tokenUrl
        }&ttype=${
            this.rootStore.authStore.token.type}`
	}
}

export default PatientsByCategoryReportListViewStore;